module.exports = __webpack_public_path__ + "bec5d2176008e0967058bcc473edf0a1.png";